import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { OfficeModalContainerComponent } from './modal-container.component';

@NgModule({
	imports: [CommonModule],
	declarations: [OfficeModalContainerComponent],
	exports: [OfficeModalContainerComponent],
})
export class OfficeModalContainerModule {}
